<nav class="py-4 relative z-50 flex items-center bg-white pr-4 xl:pr-12 2xl:pr-24">

  <div class="flex items-center">
    <a rel="follow" href="" class="flex items-center lg:w-32 xl:w-36 2xl::w-auto ml-8 min-w-[8rem] xl:ml-14 2xl:ml-20">
      <img
        src="assets/icon/logo.svg"
        class="mr-1 h-12 w-auto"
        alt="لوگوی ایرانی اکسپرت"
        title="IRaniExpert-logo"
        width="34"
        height="20"
        loading="lazy"
      />
    </a>
  
    <ul class="gap-8 flex items-center" aria-label="منوی ایرانی اکسپرت">
      <li *ngFor="let item of menuItems.slice(0,7)" 
          class="menu-item" 
          [class.has-dropdown]="item.sub"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          
        <ng-container *ngIf="item.activeRoute">
          <a rel="follow" class="text-sm xl:text-base text-center item-menu-link" [routerLink]="item.path">
            {{ item.name }}
          </a>
        </ng-container>
        <ng-container *ngIf="!item.activeRoute">
          <p class="text-sm xl:text-base text-center font-medium item-menu-link cursor-pointer">
            {{ item.name }}
          </p>
        </ng-container>

    
        <ul *ngIf="item.sub" aria-label="menu subitem" class="dropdown w-32 xl:w-40">
          <div class="dropdown-arrow"></div>
          <li *ngFor="let subItem of item.sub">
            <a rel="follow" class="text-sm xl:text-base text-center" [routerLink]="subItem.path">{{ subItem.name }}</a>
          </li>
        </ul>
      </li>
    </ul>    
  </div>
  
<div class="xl:-ml-4 relative">

  <button class="circle-btn"
    (click)="toggle()"
    (mouseenter)="inHover()"
    (mouseleave)="onHover()">
    <ng-container *ngIf="isHover">
      <i class="search-icon-gray w-5"></i>
    </ng-container>
    <ng-container *ngIf="!isHover">
      <i class="search-icon-white w-5"></i>
    </ng-container>
  </button>

  <!-- Dropdown با انیمیشن -->
  <div class="search-dropdown" [class.open]="open">
    <input
      aria-label="جستجو"
      type="text"
      class="search-input"
      placeholder="جستجو..."
      (input)="fillValue($any($event.target).value)"
    />  
  </div>
</div>

  <ng-container *ngIf="!isLogin">
    <div class="mx-4 flex items-center xl:mr-10">
      <ng-container *ngFor="let item of userLogin">
        <button
        aria-label="عضویت و ورود"
        type="button"
        name="login"
        (click)="openModal(item.type)"
        class="font-medium px-6 rounded-full py-2"
        [style]="{ 'background-color': item.bg, 'color': item.color }">
        {{item.text}}
      </button>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="isLogin">
    <ul class="gap-8 flex items-center mx-5 xl:mr-10 2xl:mr-20" aria-label="کاربران ایرانی اکسپرت">
      <li 
        *ngFor="let item of userItems;let i = index"
        class="menu-item"
        [class.has-dropdown]="item.sub"
        [class.cursor-pointer]="i === 0"
        (click)="logOutUser(i)">
        <ng-container *ngIf="!item.isLink">
          <i [ngClass]="item.icon"></i>
        </ng-container>
         <ng-container *ngIf="item.isLink">
          <a rel="nofollow" [href]="item.link" target="_blank">
            <i [ngClass]="item.icon"></i>
          </a>
        </ng-container>
  
        <ul aria-label="menu subitem" class="dropdown !w-16">
          <div class="dropdown-arrow"></div>
          <li *ngFor="let subItem of item.sub">
           <ng-container *ngIf="!item.isLink">
            <p class="text-xs" (click)="logOutUser(i)">{{ subItem.text }}</p>
           </ng-container>
           <ng-container *ngIf="item.isLink">
            <a rel="nofollow" [href]="item.link" target="_blank"><p class="text-xs">{{ subItem.text }}</p></a>
           </ng-container>
          </li>
        </ul>
      </li>
    </ul>
  </ng-container>

</nav>
  